const classes = {
  postedButton: {
    backgroundColor: 'common.lightGreen',
    color: 'primary.main',
    '&:hover': {
      backgroundColor: 'common.secondaryButtonHover',
      color: 'primary.main',
    },
  },

  cancelButton: {
    backgroundColor: 'secondary.main',
    color: 'primary.main',
  },

  promo: { fontSize: 14, fontWeight: '500' },

  cancelRequestButton: {
    backgroundColor: 'secondary.main',
    color: 'primary.main',
  },

  counterOfferBtn: {
    backgroundColor: 'common.lightGreen',
    border: 'none',
  },

  counterOfferContainer: {
    marginBottom: 2,
  },

  applyContainer: {
    backgroundColor: 'pharmacist.requestedLight',
    pt: '15px',
    borderRadius: '16px',
    borderTopLeftRadius: 0,
  },

  applyNote: {
    fontSize: 12,
    fontWeight: '500',
    color: 'common.grey850',
  },

  contractValueContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },

  contractValueNote: {
    fontSize: 16,
    fontWeight: '600',
    color: 'grey.800',
  },

  padTop: { pt: '15px' },
  stackedBox: {
    mb: '12px',
  },
  customServiceCard: {
    mb: 0,
  },

  promoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },

  promoText: {
    fontSize: 13,
    fontWeight: '500',
    color: 'primary.main',
  },
};

export default classes;
